import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "absolute h-40 right-10 inset-y-12" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-lg font-poppins text-black" }
const _hoisted_5 = { class: "mt-0 lg:mt-4" }
const _hoisted_6 = { class: "flex items-center font-poppins-bold" }
const _hoisted_7 = { class: "leading-7" }
const _hoisted_8 = {
  key: 0,
  class: "mb-1 tracking-wide font-poppins-bold text-4xl"
}
const _hoisted_9 = {
  key: 0,
  class: "mt-6 mb-2 text-black font-poppins"
}
const _hoisted_10 = { class: "font-poppins text-black" }
const _hoisted_11 = {
  key: 1,
  class: "mt-6 mb-2 text-black font-poppins text-xs"
}
const _hoisted_12 = { class: "mt-2 mb-6 space-y-2 block font-poppins text-sm disc list-inside h-28" }
const _hoisted_13 = { class: "text-sm" }
const _hoisted_14 = { class: "ml-3 text-black" }
const _hoisted_15 = { class: "ml-3 text-black" }
const _hoisted_16 = { class: "text-sm" }
const _hoisted_17 = { class: "ml-3 text-black" }
const _hoisted_18 = {
  key: 0,
  class: "max-w-48 flex rounded-full bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark p-0.5 shadow-md mb-4"
}
const _hoisted_19 = {
  key: 1,
  class: "max-w-48 flex rounded-full bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark p-0.5 shadow-md mb-4"
}
const _hoisted_20 = ["href"]

import { CheckIcon } from '@heroicons/vue/outline';
import { computed, ref } from 'vue';
import { BrandServiceInterface, PlanSelectorProductInformation } from '@/services/brand/brandServiceInterface';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';

type Product = {
  id: string,
  name: string,
  description: string,
  download: number | null,
  upload: number | null,
  typicalEveningSpeed: number | null,
  price: number,
  discountedPrice?: number,
  discounted?: boolean,
  displayDiscount?: boolean,
  img?: string,
  imghover?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PlanSelectorProduct2',
  props: {
    canSelectProduct: { type: Boolean },
    isSelectedProduct: { type: Boolean },
    product: {},
    planSelectorProductInformation: {}
  },
  emits: ["onPlanSelected"],
  setup(__props: any, { emit: __emit }) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const props = __props;

const emit = __emit;

const mostPopular = computed(() => {
  return props.product.download === 250
    ? 'text-white hover:bg-brand-primary'
    : 'text-brand-secondary hover:bg-brand-primary';
});

const standardFeatures = ref(props.planSelectorProductInformation.standardFeatures).value;
const standardLinks = ref(props.planSelectorProductInformation.standardLinks).value;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('onPlanSelected', _ctx.product.id))),
    class: _normalizeClass(["group relative my-2 lg:my-0 rounded-2xl flex flex-col bg-opacity-70 transition ease-in-out duration-100 hover:rounded-2xl hover:bg-gradient-to-tr hover:from-brand-primary-light hover:to-brand-primary-dark hover:p-1", { 'bg-opacity-100': !_ctx.isSelectedProduct, 'bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark p-1': _ctx.isSelectedProduct, 'cursor-pointer': _ctx.canSelectProduct }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["transition ease-in-out group-hover:bg-white p-8 rounded-xl border-black border-solid border hover:border-none", [_ctx.isSelectedProduct? 'bg-white border-none' : 'bg-opacity-70 bg-white']])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          class: "absolute right-0 opacity-100 group-hover:opacity-0 transition-opacity ease-in-out duration-300",
          src: _ctx.product.img
        }, null, 8, _hoisted_2),
        _createElementVNode("img", {
          class: "absolute right-0 opacity-0 group-hover:opacity-100 transition-opacity ease-in-out duration-300",
          src: _ctx.product.imghover
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["flex-1 group-hover:pt-2", [_ctx.isSelectedProduct? 'pt-2' : 'pt-0']])
      }, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.product.name), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", {
                class: _normalizeClass(['tracking-wide font-poppins-bold', _ctx.product.displayDiscount ? 'text-2xl text-gray-300 text-decoration-line: line-through' : 'text-4xl font-poppins-bold'])
              }, "$" + _toDisplayString(_ctx.product.price), 3),
              (_ctx.product.displayDiscount)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, "$" + _toDisplayString(_ctx.product.discountedPrice), 1))
                : _createCommentVNode("", true)
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "-mt-2 ml-1 text-md font-poppins" }, "/month", -1))
          ])
        ]),
        (_ctx.product.typicalEveningSpeed)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.product.typicalEveningSpeed) + " Mbps", 1),
              _cache[2] || (_cache[2] = _createTextVNode(" typical evening speed"))
            ]))
          : (_ctx.product.typicalEveningSpeed === 0 || !_ctx.product.typicalEveningSpeed)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Average sampled evening speed not currently available"))
            : _createCommentVNode("", true),
        _createElementVNode("ul", _hoisted_12, [
          _createElementVNode("li", _hoisted_13, [
            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.product.description), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(standardFeatures), (standardFeature) => {
            return (_openBlock(), _createElementBlock("li", {
              key: standardFeature,
              class: "text-sm"
            }, [
              _createElementVNode("p", _hoisted_15, _toDisplayString(standardFeature), 1)
            ]))
          }), 128)),
          _createElementVNode("li", _hoisted_16, [
            _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.product.download) + "/" + _toDisplayString(_ctx.product.upload) + " (Mbps download/upload)", 1)
          ])
        ])
      ], 2),
      (!_ctx.canSelectProduct)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[3] || (_cache[3] = [
            _createElementVNode("button", {
              class: "flex-1 text-18 bg-white group-hover:bg-transparent px-6 py-3 rounded-full font-poppins border-none hover:cursor-pointer",
              onclick: "javascript:document.getElementById('primary-address-search').focus()"
            }, " Check Your Address ", -1)
          ])))
        : _createCommentVNode("", true),
      (_ctx.canSelectProduct)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("button", {
              class: _normalizeClass(["cursor-pointer flex-1 text-18 group-hover:bg-transparent px-6 py-3 rounded-full font-poppins border-none", [_ctx.isSelectedProduct? 'bg-transparent' : 'bg-white']])
            }, _toDisplayString(_ctx.isSelectedProduct ? 'Selected' : 'Select Plan'), 3)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(standardLinks), (standardLink) => {
        return (_openBlock(), _createElementBlock("a", {
          key: standardLink.name,
          href: standardLink.link,
          target: "_blank",
          class: "block href text-black hover:text-brand-primary hover:underline transition duration-400 my-1 font-poppins-bold text-18 group-hover:pb-2 pt-1"
        }, _toDisplayString(standardLink.name), 9, _hoisted_20))
      }), 128))
    ], 2)
  ], 2))
}
}

})